import { render, staticRenderFns } from "./organization-super-admin.vue?vue&type=template&id=559b3a96&"
import script from "./organization-super-admin.vue?vue&type=script&lang=js&"
export * from "./organization-super-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports